<header>
    <div>
      <a routerLink="/" routerLinkActive="active">
        <img class="logo" src="assets/images/logo_641020.svg" alt="logo" />
      </a>
      
    </div>  
  </header>